"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSize = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
var domUtilities_1 = require("../utils/domUtilities");
/**
 * @internal
 */
var AutoSize = /** @class */ (function (_super) {
    tslib_1.__extends(AutoSize, _super);
    function AutoSize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            width: 0,
            height: 0,
        };
        _this.updateSize = function () {
            var _a = domUtilities_1.elementRegion(_this.wrapperRef.current), width = _a.width, height = _a.height;
            _this.setState({
                width: width,
                height: height,
            });
        };
        _this.throttledUpdateSize = throttle_1.default(_this.updateSize, 250, { leading: false });
        _this.wrapperRef = react_1.createRef();
        return _this;
    }
    AutoSize.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, width = _a.width, height = _a.height;
        return (react_1.default.createElement("div", { ref: this.wrapperRef, style: { height: "100%", width: "100%" } }, children({ width: width, height: height })));
    };
    AutoSize.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.throttledUpdateSize);
        this.throttledUpdateSize();
    };
    AutoSize.prototype.componentWillUnmount = function () {
        this.throttledUpdateSize.cancel();
        window.removeEventListener("resize", this.throttledUpdateSize);
    };
    return AutoSize;
}(react_1.Component));
exports.AutoSize = AutoSize;
//# sourceMappingURL=AutoSize.js.map